import { lazy } from 'react';
import { Permission } from '@condo/domain';
import type { RamRouteObject } from '@/shared/lib/permissions';

const EstateRenovationOverviewPage = lazy(() => import('@/pages/renovation-overview/EstateRenovationOverviewPage'));

export const renovationOverviewRoutes: RamRouteObject[] = [
    {
        path: 'renovation-overview',
        element: <EstateRenovationOverviewPage />,
        permissions: [Permission.EstateRenovationSummaryView],
        name: 'renovation-overview.list',
    },
];
